type Hosts = Record<string, string>;

export const GSSKT_HOST = process.env.NEXT_PUBLIC_DOMAIN_URL;

export const LIIGA_HOST: Hosts = {
  production: 'https://next.gaishishukatsu.com',
  staging: 'https://dev.next.gaishishukatsu.com',
  sirloin: 'https://dev.next.gaishishukatsu.com',
  tongue: 'https://dev.next.gaishishukatsu.com',
  development: 'https://dev.next.gaishishukatsu.com',
};

export const GSSKT_TWITTER_URL = 'https://twitter.com/gaishishukatsu';

export const GSSKT_FACEBOOK_URL = 'https://www.facebook.com/gaishishukatsu';

export const GSSKT_YOUTUBE_URL =
  'https://www.youtube.com/channel/UC9_2jJe84pFJbufV_hQ9-Pg';

export const GSSKT_YOUTUBE_SUBSCRIBE_URL = `${GSSKT_YOUTUBE_URL}?sub_confirmation=1`;

export const GSSKT_INSTAGRAM_URL = 'https://www.instagram.com/gaishishukatsu/';

export const GSSKT_TIKTOK_URL = 'https://www.tiktok.com/@gaishishukatsu_com';
